import { type ReactElement } from 'react';
import styles from './utmb-link.module.scss';
import Image from 'next/image';
import { Font } from '../text/font';
import { Link } from '@utmb/design-system/link/link';
import { getColorStyle } from '@utmb/utils/colors';
import { ColorTypesEnum } from '@utmb/types/colors';

export interface UtmbLinkProps {
    isWS: boolean;
    locale?: string;
    defaultLocale?: string;
    theme?: 'light' | 'dark';
    registered?: boolean;
}

export function UtmbLink({ isWS, locale, defaultLocale, theme, registered = true }: UtmbLinkProps): ReactElement {
    return (
        <div className={styles.utmb_link}>
            <div className={styles.logo}>
                <Image width="24" height="24" src={`/svg/utmb-logo${theme === 'dark' ? '-dark' : ''}.svg`} alt="UTMB Logo Icon" />
            </div>
            <Link href={isWS ? `/${locale !== defaultLocale ? locale : ''}` : 'https://utmb.world/'}>
                <Font.FuturaMedium
                    color={getColorStyle(theme === 'dark' ? ColorTypesEnum.PRIMARY : ColorTypesEnum.WHITE)}
                    className={styles.event_name}
                    mobile="13"
                    as="span"
                >
                    UTMB{registered ? <sup>®</sup> : null} World
                </Font.FuturaMedium>
            </Link>
        </div>
    );
}
